import { render } from "./RepricedLocksDashboard.vue?vue&type=template&id=5b5f2029&scoped=true"
import script from "./RepricedLocksDashboard.vue?vue&type=script&lang=js"
export * from "./RepricedLocksDashboard.vue?vue&type=script&lang=js"

import "./RepricedLocksDashboard.vue?vue&type=style&index=0&id=5b5f2029&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5f2029"]])

export default __exports__